import Immutable from 'immutable';

const NOT_SET = {};

/**
 * Deep merge that removes old values that are not contained in next value.
 * But missing values are always preserved on first level!
 */
export function deepMergeNested(existing, value) {
    return deepMerger(existing, value, false);
}

/**
 * Deep merge that removes old values that are not contained in next value.
 */
export function deepMerge(existing, value) {
    return deepMerger(existing, value, true);
}

function deepMerger(existing = NOT_SET, value, shouldRemoveUnused) {
    if (existing === NOT_SET || value === null) {
        return value;
    }
    if (Immutable.Map.isMap(existing) && !Immutable.OrderedMap.isOrderedMap(existing)) {
        return mergeIntoMapWith(existing, deepMerger, value, shouldRemoveUnused);
    }
    if (Immutable.List.isList(existing)) {
        return mergeIntoListWith(existing, deepMerger, value);
    }
    return Immutable.is(existing, value) ? existing : value;
}

function mergeIntoMapWith(map, merger, value, shouldRemoveUnused) {
    let iter = Immutable.Iterable.Keyed(value);
    if (!Immutable.Iterable.isIterable(value)) {
        iter = iter.map(function(v) {
            return Immutable.fromJS(v);
        });
    }
    return mergeIntoCollectionWith(map, merger, iter, shouldRemoveUnused ? removeUnusedKeys : null);
}

function removeUnusedKeys(collection, iter) {
    const toRemove = [];
    collection.keySeq().forEach(function(key) {
        if (!iter.has(key)) {
            toRemove.push(key);
        }
    });
    for (let ii = 0; ii < toRemove.length; ii++) {
        collection.remove(toRemove[ii]);
    }
}

function mergeIntoListWith(list, merger, value) {
    let iter = Immutable.Iterable.Indexed(value);
    if (iter.size > list.size) {
        list = list.setSize(iter.size);
    }
    if (!Immutable.Iterable.isIterable(value)) {
        iter = iter.map(function(v) {
            return Immutable.fromJS(v);
        });
    }
    return mergeIntoCollectionWith(list, merger, iter, removeUnusedIndexes);
}

function removeUnusedIndexes(collection, iter) {
    collection.setSize(iter.size);
}

function mergeIntoCollectionWith(collection, merger, iter, removeUnusedFn) {
    if (iter.size === 0) {
        return collection.size === 0 || !removeUnusedFn ? collection : collection.constructor(iter);
    }
    if (collection.size === 0 && !collection.__ownerID) {
        return collection.constructor(iter);
    }
    return collection.withMutations(function(coll) {
        const mergeIntoMap = function(value, key) {
            coll.update(key, NOT_SET, function(existing) {
                return existing === NOT_SET ? value : merger(existing, value, true);
            });
        };

        iter.forEach(mergeIntoMap);
        if (removeUnusedFn) {
            removeUnusedFn(coll, iter);
        }
    });
}
